import base from './base';

const templateAPI = dispatch => {
    return {
        async download(email) {
            const response = await base.publicApi(dispatch, {
                path: '/templates/download',
                method: 'post',
                data : {
                    'email' : email
                }
            });
            return response;
        },
    }
}

export default templateAPI;